import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-head-desc',
  templateUrl: './head-desc.component.html'
})
export class HeadDescComponent {
  @Input() section: any;
}
